// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2819":"fe760515","4068":"46debe39"}[chunkId] + ".chunk.css";
};